import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    @mixin font($family:'Pretendard', $size: '100px', $weight: '700', $lineHeight: '120%') {
        font-family: $family;
        font-size: $size;
        font-weight: $weight;
        line-height: $lineHeight;
    }

    :root{
        --color-red:red;
    }

`;

export default GlobalStyle;
